import React from 'react';
import { Flex, Box, useBreakpointValue } from '@chakra-ui/react';
import Sidebar from './components/Sidebar';
import ChatWindow from './components/ChatWindow';
import { useSocket } from '../../../contexts/SocketContext';
import { useChatLogic } from './hooks/useChatLogic';
import { CHAT_EVENTS } from './constants/chatEvents';
import { useGlobal } from '../../../contexts/GlobalContext';

export default function Chats() {
  const socket = useSocket();
  const { company } = useGlobal();
  const isMobile = useBreakpointValue({ base: true, md: false });

  // Use the senior-level logic hook to manage all chat state and socket events
  const {
    conversations,
    messages,
    activeChat,
    setActiveChat,
    sendMessage,
    findItem,
    sendTypingStatus,
    isPartnerTyping,
    loadMore,
    hasMore,
    isLoadingMore
  } = useChatLogic(socket);

  const syncCode = company?.setting?.syncCode;

  // Switch chat conversation
  const handleSelectChat = (chat, activeChatId) => {
    if (socket?.connected) {
      socket.emit(CHAT_EVENTS.LEAVE_CHAT, { chatId: activeChatId });
      console.log("LEAVE_CHAT");
      if (Number(chat?.unreadCount) > 0) {
        socket.emit(CHAT_EVENTS.READ_MSG, { chatId: chat.id });
        console.log("READ_MSG");
      }
    }
    setActiveChat(chat);
  };

  return (
    <Box h="calc(100vh - 110px)" overflow="hidden" overflowX="hidden" m={0} mt="3.5rem">
      <Flex h="full" w="full" overflow="hidden">
        {/* Sidebar: Show on desktop, or on mobile only if no active chat */}
        {(!isMobile || !activeChat) && (
          <Sidebar
            conversations={conversations}
            activeChatId={activeChat?.id}
            onSelectChat={handleSelectChat}
            onFindItem={(name) => findItem(name)}
          />
        )}

        {/* Chat Window: Show on desktop, or on mobile only if active chat exists */}
        {(!isMobile || activeChat) && (
          <ChatWindow
            chat={activeChat}
            messages={messages}
            isPartnerTyping={isPartnerTyping}
            onSendMessage={(data) => {
              if (data.type === "TEXT") {
                sendMessage(null, data.text, 'TEXT', { syncCode })
              } else {
                sendMessage(data.url, data.text, data.type, { syncCode })
              }
            }}
            onTyping={sendTypingStatus}
            onBack={() => setActiveChat(null)}
            onLoadMore={loadMore}
            hasMore={hasMore}
            isLoadingMore={isLoadingMore}
          />
        )}
      </Flex>
    </Box>
  );
}
